import { prisma } from "@/lib/db";
import { initializeFocusSet, getSetCounts } from "@/lib/scheduler";
import { NextRequest, NextResponse } from "next/server";

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId } = body;

    if (!userId) {
      return NextResponse.json(
        { error: "userId is required" },
        { status: 400 }
      );
    }

    // Ensure user exists (create if not)
    await prisma.user.upsert({
      where: { id: userId },
      update: {},
      create: { id: userId },
    });

    // Ensure Focus set is initialized
    await initializeFocusSet(userId);

    // Get current counts for expected accuracy
    const counts = await getSetCounts(userId);
    const masteryPercent = counts.focusCount > 0
      ? counts.focusCorrectCount / counts.focusCount
      : 0;

    // Create session record
    const session = await prisma.studySession.create({
      data: {
        userId,
        mode: "focus", // New single mode
        plannedSize: 12, // Normal session size
        expectedAccuracy: masteryPercent,
      },
    });

    return NextResponse.json({
      sessionId: session.id,
      focusCount: counts.focusCount,
      focusCorrectCount: counts.focusCorrectCount,
      masteryPercent: Math.round(masteryPercent * 100),
      newCount: counts.newCount,
      oldCount: counts.oldCount,
    });
  } catch (error) {
    console.error("Error creating session:", error);
    return NextResponse.json(
      { error: error instanceof Error ? error.message : "Failed to create session" },
      { status: 500 }
    );
  }
}
